import { GlobalSettingsService } from './../gobal-settings.service';
import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { FiltreService } from 'src/app/core/filtre.service';
import { SelectSocietyModalComponent } from 'src/app/shared/components/modals/select-society-modal/select-society-modal.component';
import { FilterBcDTO } from 'src/app/shared/dtos/filterBcDTO';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { DashboardModel } from 'src/app/shared/dtos/dashboard.model';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { StateService } from 'src/app/shared/services/state.service';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { BpLineModel } from 'src/app/shared/models/societe-linked/bp/bp-line.model';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { Title } from '@angular/platform-browser';
import { FilterBpDTO } from 'src/app/shared/dtos/filterBpDTO';
import { environment } from 'src/environments/environment';
import { UserModelDTO } from 'src/app/shared/dtos/userModelDTO';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { ParamLandpageService } from 'src/app/shared/services/utilities/param-landpage.service';
import { ParamLandpageModel } from 'src/app/shared/models/simple-types/param-landpage.model';
import { DefinitionDroitsBC } from 'src/app/shared/droitsDefinitions';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  myOpenOrderCount = 0;
  myOrderToPayCount = 2;
  society: SocieteModel;
  dataBC: BcLineModel[] = [];
  dataBP: BpLineModel[] = [];
  matDataSourceBC: MatTableDataSource<BcLineModel>;
  displayedColumnsBC: string[] = ['date', 'libelle', 'numBC', 'ca1', 'site', 'total', 'statutBC', 'statutBP', 'nombre'];
  matDataSourceBP: MatTableDataSource<BpLineModel>;
  displayedColumnsBP: string[] = ['date', 'libelle', 'numBC', 'ca1', 'site', 'total', 'statutBC', 'statutBP', 'nombre'];

  bcList: BcModel[];
  bcDashboard = new DashboardModel();
  bcDashboardAllLoaded = false;
  bcDashboardMesBcLoaded = false;
  bpDashboard = new DashboardModel();
  countBcAValider = 0;
  countBcBrouillons = 0;
  countBcValideRecent = 0;
  countBcAReceptionner = 0;
  countBcTraitesRecemment = 0;
  countBcRefuses = 0;
  countBcValidesASuivre = 0;
  countBcBloques = 0;

  bpList: BpModel[];
  countBpAValider = 0;
  countBpBrouillons = 0;
  countBpTraitesRecemment = 0;
  countBpRefuses = 0;
  countBpValidesASuivre = 0;
  countBpBloques = 0;
  filtre: any;

  libelleBC = "BC";
  btnVal;
  menuMesBc = false;
  menuAllBC = true;
  canEditorCreateBC = false;
  canEditorCreateBP = false;
  canValidateBC = false;
  canValidateBP = false;
  bpDisplayState: any;
  environment: boolean = environment.BP_ACTIF;
  user : UtilisateurModel;

  paramLandpage: ParamLandpageModel[];

  constructor(public dialog: MatDialog,
              private router: Router,
              private title: Title,
              private state: StateService,
              private bcService: BcService,
              private bpService: BpService,
              private filtreService: FiltreService,
              private globalSettingsService: GlobalSettingsService,
              private paramLandpageService: ParamLandpageService
              ) {
    this.bpDisplayState = this.globalSettingsService.bpDisplayState;
    this.btnVal = localStorage.getItem("FiltreMenuP");
    if (!this.btnVal) {
      this.btnVal = 'Mes BC';
      this.menuAllBC = true;
      this.menuMesBc = false;
      localStorage.setItem("FiltreMenuP", "Mes BC");
    }
    if (this.btnVal != "Mes BC") {
      this.menuAllBC = false;
      this.menuMesBc = true;
    }
    
    this.state.society.subscribe(result => {
      this.society = result;
    });
    this.filtreService.filtre.subscribe(result => {
      this.filtre = result;
    });
    this.paramLandpageService.getAll().subscribe(result => {
      this.paramLandpage = result;
      for (let btn of this.paramLandpage) {
        btn.haveUrl = btn.urlBouton ? true : false;
      }
    });
    const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    this.user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    const droitsBC = user?.droits.filter(droit =>
          (droit.niveau === DefinitionDroitsBC.CREER) &&
          (droit.type === 'BC')
        );
    const droitsBP = user?.droits.filter(droit =>
          (droit.niveau === DefinitionDroitsBC.CREER) &&
          (droit.type === 'BC')
        );
    const droitsValidationBP = user?.droits.filter(droit =>
          (droit.niveau === DefinitionDroitsBC.VALS0 || droit.niveau ===DefinitionDroitsBC.VALS1 || droit.niveau === DefinitionDroitsBC.VALS2 || droit.niveau === DefinitionDroitsBC.VALS3 || droit.niveau === DefinitionDroitsBC.VALS4)
          &&
          (droit.type === 'BC')
        );
    const droitsValidationBC = user?.droits.filter(droit =>
          (droit.niveau === DefinitionDroitsBC.VALS0 || droit.niveau ===DefinitionDroitsBC.VALS1 || droit.niveau === DefinitionDroitsBC.VALS2 || droit.niveau === DefinitionDroitsBC.VALS3 || droit.niveau === DefinitionDroitsBC.VALS4)
          &&
          (droit.type === 'BC')
        );
    if (droitsBC && droitsBC.length > 0) {
        this.canEditorCreateBC = true;
      }
    if (droitsBP && droitsBP.length > 0) {
        this.canEditorCreateBP = true;
      }
    if (droitsValidationBP && droitsValidationBP.length > 0) {
        this.canValidateBP = true;
      }
    if (droitsValidationBC && droitsValidationBC.length > 0) {
        this.canValidateBC = true;
      }
  }

  ngOnInit(): void {
    this.matDataSourceBC = new MatTableDataSource(this.dataBC);
    this.matDataSourceBP = new MatTableDataSource(this.dataBP);
    if (this.menuAllBC) {
      this.bcService.getDashboardAllBcs().subscribe(value => {
        this.bcDashboardAllLoaded = true;
        this.bcDashboard.toAReceptionner = value.toAReceptionner;
        //this.bcDashboard.toBrouillon = value.toBrouillon;
        this.bcDashboard.toLitige  = value.toLitige;
        this.bcDashboard.toRefuse = value.toRefuse;
        //this.bcDashboard.toValide = value.toValide;
        this.bcDashboard.toValideRecent = value.toValideRecent;
        this.bcDashboard.toWaitValidation = value.toWaitValidation;
      });
    } else {
      this.bcService.getDashboardMyBcs().subscribe(value => {
        this.bcDashboardMesBcLoaded = true;
        this.bcDashboard.toMyAReceptionner = value.toMyAReceptionner;
        //this.bcDashboard.toMyBrouillon = value.toMyBrouillon;
        this.bcDashboard.toMyLitige  = value.toMyLitige;
        this.bcDashboard.toMyRefuse = value.toMyRefuse;
        //this.bcDashboard.toMyValide = value.toMyValide;
        this.bcDashboard.toMyValideRecent = value.toMyValideRecent;
        this.bcDashboard.toMyWaitValidation = value.toMyWaitValidation;
      });
    }

    if (this.canValidateBC) {
      this.bcService.getDashboardValidationBcs().subscribe(value => {
        this.bcDashboard.toWaitValidationByMe = value.toWaitValidationByMe;
        //this.bcDashboard.toRecent = value.toRecent;
        this.bcDashboard.toBloque = value.toBloque;
      });
    }

    if (this.bpDisplayState) {
      this.bpService.getDashboard().subscribe(value => {
        this.bpDashboard = value;
      });
    }
    this.title.setTitle('SACHA - Accueil');
  }

  goToShowMyOrAllBC(){
    this.menuAllBC = false;
    this.menuMesBc =  !this.menuAllBC;
    if(this.btnVal == 'Mes BC'){
      this.btnVal = 'Tous';
      this.libelleBC="Mes BC";
      localStorage.setItem("FiltreMenuP",'Tous');
      if (!this.bcDashboardMesBcLoaded) {  
        this.bcService.getDashboardMyBcs().subscribe(value => {
          this.bcDashboardMesBcLoaded = true;
          this.bcDashboard.toMyAReceptionner = value.toMyAReceptionner;
          //this.bcDashboard.toMyBrouillon = value.toMyBrouillon;
          this.bcDashboard.toMyLitige  = value.toMyLitige;
          this.bcDashboard.toMyRefuse = value.toMyRefuse;
          //this.bcDashboard.toMyValide = value.toMyValide;
          this.bcDashboard.toMyValideRecent = value.toMyValideRecent;
          this.bcDashboard.toMyWaitValidation = value.toMyWaitValidation;
        });
      }
    }else{
      this.btnVal = 'Mes BC'
      this.libelleBC="BC";
      localStorage.setItem("FiltreMenuP", 'Mes BC');
      this.menuAllBC = true;
      this.menuMesBc = !this.menuAllBC;
      if (!this.bcDashboardAllLoaded) {  
        this.bcService.getDashboardAllBcs().subscribe(value => {
          this.bcDashboardAllLoaded = true;
          this.bcDashboard.toAReceptionner = value.toAReceptionner;
          //this.bcDashboard.toBrouillon = value.toBrouillon;
          this.bcDashboard.toLitige  = value.toLitige;
          this.bcDashboard.toRefuse = value.toRefuse;
          //this.bcDashboard.toValide = value.toValide;
          this.bcDashboard.toValideRecent = value.toValideRecent;
          this.bcDashboard.toWaitValidation = value.toWaitValidation;
        });
      }
    }
  }

  goToMesBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.idCreateur = this.user.id;
    this.filtre.type = 'Mes_Bc';
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
  }

  goToBrouillonBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.status = ['Brouillon'];
    this.filtre.type = 's_brouillons';
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    if(this.menuMesBc){
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_BC_brouillons';
    }
  }

  goToWaitingBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.fValide = [NTHFlag.None, NTHFlag.Some];
    this.filtre.type = 's_en_attente';
    this.filtre.order = 'dBc';
    this.filtre.descending = true;
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    if(this.menuMesBc){
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_BC_en_attente';
    }
  }

  goToRefusedBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 's_refusés';
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    this.filtre.status = ['Brouillon', 'A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4', 'Validé', 'Clos'];
    if(this.menuMesBc){
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_BC_refusés';
    }
  }

  goToValidatedToFollowBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.status = ['Validé'];
    this.filtre.fValide = [NTHFlag.All];
    this.filtre.type = 's_valide_a_suivre';
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    if(this.menuMesBc){
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_BC_valide_a_suivre';
    }
  }

  goToRecentlyBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 'v_traite_recemment';
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
  }

  goToRecentlyValidatedBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 's_valide_recemment';
    this.filtre.status = ['Validé'];
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    if(this.menuMesBc){
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_BC_valide_recemment';
    }
  }

  goToAReceptionneBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 's_a_receptionner';
    this.filtre.status = ['Validé'];
    this.filtre.fLivre = [NTHFlag.Some, NTHFlag.None];
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    if(this.menuMesBc){
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_BC_a_receptionner';
    }
  }

  goToWaitingValBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 'v_en_attente';
    this.filtre.order = 'dBc';
    this.filtre.descending = true;
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
  }

  goToNonPayeBPList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 'v_non_paye';
    this.filtre.order = 'dBc';
    this.filtre.descending = true;
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
  }

  goToBlockedBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.type = 'v_bloques';
    if(route === 'list-bc') {
      this.filtre.status = ['Brouillon', 'A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4', 'Validé', 'Clos'];
    }
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
  }

  goToLitigeBcList(route: string): void {
    this.filtre = route === 'list-bc' ? new FilterBcDTO() : new FilterBpDTO();
    this.filtre.fValide = [NTHFlag.All];
    this.filtre.fLitige = [NTHFlag.Some, NTHFlag.All];
    this.filtre.type = 's_litige';
    if(route === 'list-bc') {
      this.filtre.status = ['Brouillon', 'A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4', 'Validé', 'Clos'];
    }
    route === 'list-bc' ? this.filtreService.changeFiltre(this.filtre) : this.filtreService.changeFiltreBP(this.filtre);
    this.router.navigate([route]);
    if (this.menuMesBc) {
      this.filtre.idCreateur = this.user.id;
      this.filtre.type = 'mes_Bc_litige';
    }
  }

  addBc(): void {
    this.router.navigate(['create-bc']);
  }

  duplicateBc(): void {
    this.filtre = new FilterBcDTO();
    this.filtre.type = 'duplique';
    this.filtreService.changeFiltre(this.filtre);
    this.router.navigate(['list-bc']);
  }

  addBp(): void {
    this.router.navigate(['/select-bc-for-create-bp']);
    this.filtre = new FilterBcDTO();
    this.filtre.type = 's_valide_bp';
    this.filtreService.changeFiltre(this.filtre);
  }

  addBpMulti(): void {
    // this.router.navigate(['list-bc']);
  }

  updateSociety(): void {
    this.state.changeSociety(this.society);

  }

  chooseSociety(): void {
    const dialogConfirmation = this.dialog.open(SelectSocietyModalComponent, {
      data: {
        title: 'Choisir une societé',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
    });
  }

  // BC Statistics

  loadHomePageStatisticsBC(): void {
    const bc = 'BC';
    this.bcService.getFromSociete(this.society.id).subscribe(
      purchaseOrders => {

        this.bcList = purchaseOrders;

        if (purchaseOrders !== undefined) {
          for (let index = 0; index < purchaseOrders.length; index++) {
            /* BC A valider*/
            this.getCountValidate(purchaseOrders, index, bc);

            /* BC Brouillons*/
            this.getCountDraf(purchaseOrders, index, bc);

            /* BC Refusés*/
            // @NB : bc.model.ts modifié avec un champ flag nullable et mock data légèrement modifié (à voir).
            this.getCountRefused(purchaseOrders, index, bc);

            /* BC Validés à suivre*/
            this.getCountValidatedToFollow(purchaseOrders, index, bc);

            /* BC Traités récemment*/
            this.getCountRecentlyTreated(purchaseOrders, index, bc);

            /* BC Bloqués*/
            // @NB : bc.model.ts modifié avec un champ flag nullable et mock data légèrement modifié (à voir).
            this.getCountBlocked(purchaseOrders, index, bc);
          }
        }

      }
    );
  }

  // BP Statistics

  loadHomePageStatisticsBP(): void {
    const bp = 'BP';
    this.bpService.getFromSociete(this.society.id).subscribe(
      paymentApprovals => {

        this.bpList = paymentApprovals;

        if (paymentApprovals !== undefined) {
          // tslint:disable-next-line
          for (let index = 0; index < paymentApprovals.length; index++) {
            /* BP A valider*/
            this.getCountValidate(paymentApprovals, index, bp);

            /* BP Brouillons*/
            this.getCountDraf(paymentApprovals, index, bp);

            /* BP Refusés*/
            // @NB : bc.model.ts modifié avec un champ flag nullable et mock data légèrement modifié (à voir).
            this.getCountRefused(paymentApprovals, index, bp);

            /* BP Validés à suivre*/
            this.getCountValidatedToFollow(paymentApprovals, index, bp);

            /* BP Traités récemment*/
            this.getCountRecentlyTreated(paymentApprovals, index, bp);

            /* BP Bloqués*/
            // @NB : bc.model.ts modifié avec un champ flag nullable et mock data légèrement modifié (à voir).
            this.getCountBlocked(paymentApprovals, index, bp);
          }
        }
      }
    );
  }

  /**
   * Retourne le nombre d'élément à valider BP/BC
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
  getCountValidate(brArray: object, position: number, type: string): void {
    // tslint:disable-next-line: max-line-length
    if (brArray[position].statut === 'A valider' || brArray[position].statut === 'Validation 1' || brArray[position].statut === 'Validation 2') {
      if (type) {
        if (type === 'BC') {
          this.countBcAValider = this.countBcAValider + 1;
        } else {
          this.countBpAValider = this.countBpAValider + 1;
        }
      }
    }
  }

  /**
   * Retourne le nombre d'élément en cours de saisi, mémorisé / Brouillon BP/BC.
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
  getCountDraf(brArray: object, position: number, type: string): void {
    if (brArray[position].statut === 'Brouillon') {
      if (type) {
        if (type === 'BC') {
          this.countBcBrouillons = this.countBcBrouillons + 1;
        } else {
          this.countBpBrouillons = this.countBpBrouillons + 1;
        }
      }
    }
  }

  /**
   * Retourne le nombre d'élément refusé BP/BC.
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
  getCountRefused(brArray: object, position: number, type: string): void {
    // tslint:disable-next-line: max-line-length
    if ((brArray[position].statut === 'A valider' || brArray[position].statut === 'Validation 1' || brArray[position].statut === 'Validation 2') && (brArray[position].flag === 1 /*Retour*/)) {
      if (type) {
        if (type === 'BC') {
          this.countBcRefuses = this.countBcRefuses + 1;
        } else {
          this.countBpRefuses = this.countBpRefuses + 1;
        }
      }
    }
  }

  /**
   * Retourne le nombre d'élément validé à suivre BP/BC.
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
  getCountValidatedToFollow(brArray: object, position: number, type: string): void {
    if (brArray[position].statut === 'Validé' || brArray[position].statut === 'Livré partiel' || brArray[position].statut === 'Livré') {
      if (type) {
        if (type === 'BC') {
          this.countBcValidesASuivre = this.countBcValidesASuivre + 1;
        } else {
          this.countBpValidesASuivre = this.countBpValidesASuivre + 1;
        }
      }
    }
  }

  /**
   * Retourne le nombre d'élément validé à suivre BP/BC.
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
   getCountValidatedRecent(brArray: object, position: number, type: string): void {
    if (brArray[position].statut === 'Validé' && brArray[position].stat) {
      if (type) {
        if (type === 'BC') {
          this.countBcValidesASuivre = this.countBcValidesASuivre + 1;
        } else {
          this.countBpValidesASuivre = this.countBpValidesASuivre + 1;
        }
      }
    }
  }

  /**
   * Retourne le nombre d'élément traité récemment BP/BC.
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
  getCountRecentlyTreated(brArray: object, position: number, type: string): void {
    if ((brArray[position].statut !== 'Clos' && brArray[position].statut !== 'Annulé') // tslint:disable-next-line: max-line-length
      && (brArray[position].statut !== 'A valider' || brArray[position].statut !== 'Validation 1' || brArray[position].statut !== 'Validation 2')) {
      if (type) {
        if (type === 'BC') {
          this.countBcTraitesRecemment = this.countBcTraitesRecemment + 1;
        } else {
          this.countBpTraitesRecemment = this.countBpTraitesRecemment + 1;
        }
      }
    }
  }

  /**
   * Retourne le nombre d'élément bloqué BP/BC.
   * @param brArray - le tableau sur lequel faire le count
   * @param position - la position à inclure
   * @param type - 'BP' ou 'BC'
   */
  getCountBlocked(brArray: object, position: number, type: string): void {
    if (brArray[position].flag === 0 /*Bloqué*/) {
      if (type) {
        if (type === 'BC') {
          this.countBcBloques = this.countBcBloques + 1;
        } else {
          this.countBpBloques = this.countBpBloques + 1;
        }
      }
    }
  }

}
